import { render, staticRenderFns } from "./yltlxx.vue?vue&type=template&id=179d77e0&scoped=true"
import script from "./yltlxx.vue?vue&type=script&lang=js"
export * from "./yltlxx.vue?vue&type=script&lang=js"
import style0 from "./yltlxx.vue?vue&type=style&index=0&id=179d77e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d77e0",
  null
  
)

export default component.exports